import React  from 'react';
import { FooterSection , FooterDesc} from './style'
const Footer = () => {
    return (
        <FooterSection>
            <FooterDesc> copyright &copy; 2021 by Maya&Ayob </FooterDesc>
        </FooterSection>
    )
}

export default Footer;
